interface IContentProps {
  children: JSX.Element[];
}

export const Content: React.FC<IContentProps> = ({ children }) => {
  return <div>{children}</div>;
};
